export enum QUERY_KEYS {
  checkDuplicatedEvent = 'check-duplicate',
  createEvent = 'create-event',
  createEventImage = 'create-event-image',
  createEventWithLineup = 'create-event-with-info',
  deleteBooking = 'delete-booking',
  deleteEvent = 'delete-event',
  duplicateEvent = 'duplicate-event',
  editEvent = 'edit-event',
  editEventDelayedDeliverySettings = 'edit-event-delayed-delivery-settings',
  editEventResaleSettings = 'edit-event-resale-settings',
  editEventMaxTicketQuantityChannels = 'create-event-limits',
  eventAttendeesStats = 'event-attendees-stats',
  eventChannels = 'event-channels-by-id',
  eventChannelsSalesStats = 'event-channels-sales-stats',
  eventCustomFieldsStats = 'event-sales-custom-fields-stats',
  eventDemographicsAgeGender = 'event-demographics-age-gender',
  eventDemographicsLanguage = 'event-demographics-language',
  eventDemographicsNationality = 'event-demographics-nationality',
  eventDemographicsPurchaseLocation = 'event-demographics-purchase-location',
  eventDemographicsViewsLocation = 'event-demographics-views-location',
  eventGroups = 'event-groups',
  eventLineUp = 'event-line-up-by-id',
  eventList = 'get-event-list',
  eventReportExportBookings = 'event-report-export-bookings',
  eventReportExportPreRegistrationBookings = 'event-report-export-pre-registration-bookings',
  eventReportSalesRecap = 'event-report-sales-recap',
  eventResaleOfferStats = 'event-resale-offer-stats',
  eventResaleStatsGroupBy = 'event-resale-stats-groupby',
  eventSalesStats = 'event-sales-stats',
  eventSalesStatsAddons = 'event-sales-stats-addons',
  eventSalesStatsGroupBy = 'event-sales-stats-groupby',
  eventSections = 'event-sections',
  eventVideoCover = 'event-video-cover',
  eventViewsStats = 'event-views-stats',
  getEvent = 'event-by-id',
  getEventBooking = 'event-booking',
  getEventBookings = 'get-event-bookings',
  getEventPreRegistrations = 'get-event-preregistrations',
  getEventResaleSettings = 'event-resale-settings',
  hideEvent = 'unpublish-event',
  publishEvent = 'publish-event',
  resetEventDelayedDeliverySettings = 'reset-event-delayed-delivery-settings',
  resetEventResaleSettings = 'reset-event-resale-settings',
  revealLocation = 'reveal-location-to-ticket-holders',
}
